import styled from 'styled-components';
import { colors, media, spacing } from '../../../../App/ChakraTheme';

export const GuidesPageWrapper = styled.div`
  padding: 0 ${spacing.BASE_PLUS} ${spacing.BASE_PLUS};
  justify-content: center;
  align-items: center;
  min-height: 100vh;

  @media (max-height: 900px) {
    min-height: calc(100vh + 140px);
  }

  ${media.tablet`
  .hide-tablet{display:none;}
`};
  ${media.phone`
  .hide-phone{display:none;}
`};

  .content-title-container {
    padding-left: 14px;
    position: relative;
    padding-bottom: ${spacing.SMALL};
    &:before {
      content: '';
      height: 100%;
      width: 1px;
      position: absolute;
      background-color: rgba(213, 214, 222, 0.4);
      left: 21px;
    }
  }

  .content-title {
    padding-left: ${spacing.TINY};
    flex-shrink: 0;
    svg {
      margin-right: ${spacing.TINY};
      flex-shrink: 0;
    }
  }

  .content-controls {
    margin-top: ${spacing.SMALL};
    margin-bottom: ${spacing.SMALL};
    flex-wrap: wrap;
    flex-shrink: 0;
    .chakra-button {
      margin: ${spacing.TINY};
      white-space: nowrap;
      font-size: 12px;
      max-height: 40px;
      min-height: 40px;
      ${media.tablet`
      min-width: auto !important;
      min-height: auto !important;
      padding: 0 12px !important;
      min-width: ${spacing.LARGE} !important;
      height: ${spacing.LARGE} !important;
      flex-shrink: 0 !important;
      justify-content: center;
      align-items: center;
      svg{
        margin: 0 !important;
        flex-shrink: 0;
      }
    `}
    }
  }

  .module {
    width: 100%;
    flex-shrink: 0;
    flex-grow: 0;
    flex-basis: auto;
    padding-right: 15px;
    position: relative;
    &:not(:last-of-type) .module-title:after,
    .module-title.active-module:after {
      content: '';
      height: calc(100% - 44px);
      width: 1px;
      position: absolute;
      background-color: rgba(213, 214, 222, 0.2);
      left: 21px;
      top: 43px;
      z-index: 0;
    }
  }

  .module-title {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    padding-bottom: ${spacing.SMALL};
    position: relative;
    transition: padding-bottom 400ms;
    &:before {
      background-color: #fff;
      margin-right: 16px;
      content: attr(data-number);
      width: 42px;
      height: 42px;
      border: 1px solid rgba(213, 214, 222, 0.8);
      border-radius: 50%;
      text-align: center;
      font-weight: 300;
      font-size: 24px;
      color: rgb(213, 214, 222);
      transition: all 400ms;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-shrink: 0;
      z-index: 1;
    }
    .chakra-stack {
      width: 100%;
      height: 100%;
      justify-content: space-between;
      align-items: center;
    }
    svg {
      transition: transform 400ms;
      margin-left: ${spacing.TINY};
      flex-shrink: 0;
      transform: rotate(90deg);
      path[fill] {
        fill: ${colors.darkblue};
      }
    }

    &.active-module {
      padding-bottom: ${spacing.TINY};
      svg {
        transform: rotate(90deg) scaleX(-1);
      }
      &:before {
        border-color: rgb(18, 18, 59);
        color: rgb(18, 18, 59);
      }
    }
  }

  iframe,
  canvas {
    height: 100vh !important;
    width: 100% !important;
    flex-grow: 1;
    flex-basis: 100vh;
    padding-right: ${spacing.TINY};
    padding-left: ${spacing.TINY};
  }
  iframe:fullscreen,
  iframe:-webkit-full-screen {
    width: 100vw !important;
    height: 100vh !important;
    padding: 0;
  }
`;
